import { useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoComponent from "../../components/Logos/LogoComponent";
import BackButton from "../../components/buttons/BackButton";
import { useSearchParams } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3080";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const navigate = useNavigate();

  const handleFormSubmit = (e) => {
    e.preventDefault();

    let formIsValid = true;
    setNewPasswordError("");
    setConfirmPasswordError("");

    if (newPassword.length < 8) {
      formIsValid = false;
      setNewPasswordError("The password must be 8 characters or longer");
    }

    if (newPassword !== confirmPassword) {
      formIsValid = false;
      setConfirmPasswordError("The passwords must match");
    }

    if (formIsValid) {
      const token = searchParams.get("token");
      fetch(`${API_URL}/resetPassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ newPassword: newPassword }),
      })
        .then((r) => r.json())
        .then((r) => {
          if (r.message === "success") {
            if (
              window.confirm(
                "Your password has been reset successfully. Please continue to login."
              )
            ) {
              navigate("/login");
            }
          } else {
            alert(r.message);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100 justify-content-center align-items-center">
      <div style={{ width: "30rem" }}>
        {/* LOGO */}
        <div className="mb-4">
          <LogoComponent />
        </div>

        {/* CONTAINER */}
        <div className="container d-flex flex-column justify-content-center align-items-start gap-4">
          {/* BACK BUTTON */}
          <div className="me-auto">
            <BackButton />
          </div>

          {/* RESET PASSWORD */}
          <div>
            <h3 className="heading-secondary mb-3">Reset Password?</h3>
            <p style={{ fontSize: "1.2rem" }}>
              Please enter a new password.
            </p>
          </div>

          {/* FORM */}
          <form onSubmit={handleFormSubmit} noValidate className="w-100">
            <div className="mb-5">
              <div>
                {/* <label for="inputEmail" class="form-label">
                Email
              </label> */}
                <input
                  className="form-control mb-5"
                  id="inputPassword"
                  type="password"
                  name="inputPassword"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
                <label className="form-label errorLabel">
                  {newPasswordError}
                </label>
              </div>
              <div>
                <input
                  className="form-control"
                  id="retypePassword"
                  type="password"
                  name="retypePassword"
                  placeholder="Re-type Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
              <label className="errorLabel">{confirmPasswordError}</label>
            </div>
            <button
              className="btn  fw-bold bg-main-purple w-100"
              // Need to fix this friggin' size
              style={{ width: "30rem" }}
            >
              Continue
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
